import { Component, Input, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { concatMapTo, count } from 'rxjs';
import { CryptoService } from 'src/app/services/crypto.service';
import { DataService } from 'src/app/services/data.service';
import { GlobalConstants } from 'src/app/services/global-constants';
import { PermissionHandlerService } from 'src/app/services/permission-handler.service';
import { PermissionLoaderService } from 'src/app/services/permission-loader.service';

@Component({
  selector: 'app-home-searchbar',
  templateUrl: './home-searchbar.component.html',
  styleUrls: ['./home-searchbar.component.scss']
})
export class HomeSearchbarComponent {
  searchText = '';
  @Input() ous: any;
  filteredOus: any;
  recentsearches: any = [];
  serviceCounts: any = undefined;
  showServiceCount: boolean = false;
  visibleModal: boolean = false;
  staticURL: string = GlobalConstants.staticFilesURL;
  currentFieldType: any;
  constructor(
    private router: Router,
    private dataService: DataService,
    private cryptoService: CryptoService,
    private permissionService: PermissionHandlerService,
    private permisssionLoader: PermissionLoaderService
  ) { }

  isLoggedIn = JSON.parse(localStorage.getItem('isLoggedIn') || "false");

  navigateToSearch(event: any) {
    let search: string = event.target.value;
    if (search.includes("\"") || search.includes("+") || search.includes("-")) {
      this.advancedSearch(search);
      return;
    }
    let queryParams = { searchTerm: search };
    this.router.navigate(['/search-view'], { queryParams })
  }

  ngOnInit() {
    this.fetchRecentSearches();
    if (!this.isLoggedIn) {
      this.permisssionLoader.getState().subscribe(e => {
        if (!e) {
          this.fetchServiceCount();
        }
      })
    } else {
      this.fetchServiceCount();
    }

  }

  advancedSearch(search: string) {
    let query: any = { condition: 'and', rules: [] };
    query.extras = this.extractSearchParts(search);
    let encryptedQuery = this.cryptoService.encodeObject(query);
    console.log('QUERY', query);
    let params = { query: encryptedQuery };
    this.router.navigate(['/advance-search/result'], { queryParams: params })
  }

  extractSearchParts(search: string) {
    let removal: string[] = [];
    let exact: string[] = [];
    let any: string[] = [];

    // Extract exact match parts
    search = search.replace(/"(.*?)"/g, (_, match) => {
      exact.push(match);
      return ""; // Remove from original string
    });

    // Extract removal parts (after '-')
    search = search.replace(/-(\S+)/g, (_, match) => {
      removal.push(match);
      return ""; // Remove from original string
    });

    // Remaining parts (any match) after removing '+' and trimming
    const remainingParts = search.replace(/\+/g, "").trim();
    if (remainingParts) {
      any.push(...remainingParts.split(/\s+/));
    }
    let query: any = {
      likeAll: any.join(" "),
      sameWord: exact.join(" ").replaceAll("+", ""),
      notContains: removal.join("").replaceAll("+", "")
    }
    if (exact.length == 0) {
      delete query.sameWord;
    }

    if (any.length == 0) {
      delete query.likeAll;
    }

    if (removal.length == 0) {
      delete query.notContains;
    }
    return query;
  }

  searchItem(text: string) {
    this.searchText = text;
    this.navigateToSearch({ target: { value: this.searchText } })
  }

  hasPermission(unit: string, flag: string) {
    return this.permissionService.hasPermission(unit, flag)
  }

  checkisImg(arg0: string | undefined): any {
    if (arg0) {
      return /\.(jpg|jpeg|png|gif|svg)/.test(arg0);
    } else {
      return false
    }
  }

  async fetchRecentSearches() {
    try {
      let res = await this.dataService.getData('ou/search-history');
      this.recentsearches = res.data.reverse();
      if (this.recentsearches.length > 10) {
        this.recentsearches = this.recentsearches.splice(0, 10)
      }
    } catch (e) {
      console.log(e);
    }
  }

  async fetchServiceCount() {
    try {
      console.log("isloggedin ==>", this.isLoggedIn);
      if (this.isLoggedIn) {
        let res = await this.dataService.getData('data/service-count');
        if (res.error) return
        this.serviceCounts = res.data;
        console.log('service count', this.serviceCounts);
      } else {
        let signedOus = this.permissionService.payload.content.signedOus.content;
        let allOus = this.permissionService.payload.content.allOus.content;
        let payload = {
          signed: signedOus,
          all: allOus
        };

        console.log("PAYLOAD ===>>>", payload);
        let res = await this.dataService.postData('data/service-count', payload);
        if (res.error) {
          return
        } else {

          let dataArray = res.data;
          // Create a map to store the aggregated data
          const aggregatedMap = new Map<string, any>();

          console.log("check before the table")
          dataArray.forEach((item: { _id: string; count: any; signed: any; }) => {
            if (aggregatedMap.has(item._id)) {
              const existingItem = aggregatedMap.get(item._id);
              if (existingItem) {
                let check = signedOus.includes(item._id)
                console.log("ou in table check", check, signedOus, item._id)

                if (signedOus.includes(item._id)) {
                  existingItem.count += item.signed;
                } else {
                  existingItem.count += item.count;
                }
              }
            } else {
              aggregatedMap.set(item._id, { ...item });
            }
          });

          // Convert the map back to an array
          const resultArray = Array.from(aggregatedMap.values());

          this.serviceCounts = resultArray;

          console.log('service count if not logged in', this.serviceCounts);
        }
        this.showServiceCount = true;

      }
    } catch (e) {
      console.log(e);
    }
  }

  calculateCounts() {
    if (this.serviceCounts) {
      if (this.isLoggedIn) {

        this.serviceCounts = this.serviceCounts.map((s: any) => {
          let count = 0;
          this.ous.forEach((ou: any) => {
            let counter = ou.data_counter;
            if (counter.length > 0) {
              let found = counter.find((c: any) => c._id == s.type.arabic);
              if (found) {
                count += found.count;
              }
            }
          });
          s.count = count;
          return s;
        }).filter((s: any) => s.count != 0);
        this.serviceCounts = this.dataSorter(this.serviceCounts);
        this.showServiceCount = true;
      }
    }
  }

  dataSorter(dataCounter: any[]): any[] {
    const orderArray = ["الخدمات", "الأسئلة الشائعة"];

    // Sort the dataCounter array
    dataCounter.sort((a, b) => {
      const aIndex = orderArray.indexOf(a.type.arabic);
      const bIndex = orderArray.indexOf(b.type.arabic);

      // If both items are in the orderArray, sort based on their order
      if (aIndex !== -1 && bIndex !== -1) {
        return aIndex - bIndex;
      }

      // If only one of the items is in the orderArray, it comes first
      if (aIndex !== -1) {
        return -1;
      }
      if (bIndex !== -1) {
        return 1;
      }

      // If neither item is in the orderArray, sort them by their _id
      return a.type.arabic.localeCompare(b.type.arabic);
    });

    return dataCounter; // Return the sorted array
  }

  openLicenseModal(item: any) {
    this.currentFieldType = item;
    console.log(this.currentFieldType);
    console.log(this.filteredOus);
    if (this.currentFieldType) {
      this.filteredOus = this.ous.filter((ou: any) => {
        let counters = ou.data_counter;
        if (counters.length == 0) {
          return false;
        }
        let present = counters.find((c: any) => c._id == item.type.arabic);
        if (present) {
          return true;
        }
        return false;
      })
      this.visibleModal = true;
    }
  }

  ngOnChanges(simpleChange: SimpleChanges) {
    if (simpleChange['ous']) {
      this.ous = simpleChange['ous'].currentValue;
      this.filteredOus = this.ous;
      this.calculateCounts();
    }
  }

  getCount(ou: any) {

    if (this.isLoggedIn) {

      return ou.data_counter.find((d: any) => d._id == this.currentFieldType.type.arabic)?.count

    } else {
      let signedOus = this.permissionService.payload.content.signedOus.all;
      if (signedOus.includes(ou._id)) {
        return ou.data_counter.find((d: any) => d._id == this.currentFieldType.type.arabic)?.signed
      } else {
        return ou.data_counter.find((d: any) => d._id == this.currentFieldType.type.arabic)?.count
      }

    }

  }

  testCount() {
    let ouCount = 0
    this.filteredOus.forEach((ou: any) => {
      ouCount += this.getCount(ou);
    })
    return ouCount
  }

  navigateToResult(ou: any) {
    if (this.currentFieldType) {
      let query: any = {
        condition: 'and',
        rules: [],
        extras: { ou: ou.id, type: this.currentFieldType._id }
      };
      let encryptedQuery = this.cryptoService.encodeObject(query);
      let queryParams = { query: encryptedQuery };
      this.router.navigate(['/advance-search/result'], { queryParams });
    }
  }
}
